const ADDRESS_TYPE_LABELS = {
  billing: 'Billing',
  shipping: 'Shipping',
  other: 'Other'
};

/** Maps stored address_type (e.g. shipping) to the same labels as the modal dropdown. */
export function formatCustomerAddressType(type) {
  if (type == null || type === '') return '-';
  const key = String(type).trim().toLowerCase();
  if (ADDRESS_TYPE_LABELS[key]) return ADDRESS_TYPE_LABELS[key];
  const s = String(type);
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
